export default "__VITE_ASSET__DT0kV99x__"